import React from "react";
import { Box, Button } from "../../../design-system";
import { HERO_CTA } from "../constants/landingText";
import HeroSectionTitle from "./HeroSectionTitle";
import HeroSectionSubTitle from "./HeroSectionSubTitle";

interface HeroContentProps {
  onCTAClick: () => void;
  titleFontSize?: { xs: string; md: string };
  titleMaxWidth?: string;
  subtitleFontSize?: { xs: string; md: string };
  subtitleMaxWidth?: string;
}

const HeroContent: React.FC<HeroContentProps> = ({
  onCTAClick,
  titleFontSize,
  titleMaxWidth,
  subtitleFontSize,
  subtitleMaxWidth,
}) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 8,
        position: "relative",
        zIndex: 2,
      }}
    >
      <HeroSectionTitle fontSize={titleFontSize} maxWidth={titleMaxWidth} />
      <HeroSectionSubTitle
        fontSize={subtitleFontSize}
        maxWidth={subtitleMaxWidth}
      />
      <Button
        variant="ghost"
        onClick={onCTAClick}
        sx={{
          padding: { xs: "0.75rem 1.5rem", md: "0.75rem 2rem" },
        }}
      >
        {HERO_CTA}
      </Button>
    </Box>
  );
};

export default HeroContent;
